// Properties of the date object. E.g:
// Sets the fields of the date(year, month, day, hour, minutes, ...)
// Sets the timezone of the date. If none mentioned, no offset will be applied to the user agent's date.
// For example, for the EST timezone offset we could add the 'timeZone: "UTC",' option bellow
export const PARAM_DATE_OPTIONS = {
	year: "numeric",
	month: "2-digit",
	day: "2-digit",
};

export const USER_FRIENDLY_DATE_OPTIONS = {
	weekday: "short",
	calendar: "numeric",
	month: "long",
	day: "2-digit",
};

export function dateToString(theDate, theDateOptions) {
	// Format of date String.
	const DATE_FORMAT = "en-ZA"; // YYYY/MM/DD from (https://gist.github.com/mlconnor/1887156)

	// return the date in the desired format
	return theDate
		.toLocaleDateString(DATE_FORMAT, theDateOptions)
		.replaceAll("/", "-");
}
